<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import { FeedbackForm } from '@/features/feedback'

  definePage({
    meta: {
      layout: 'baseNew',
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('navigation_item_feedback'),
  })
</script>

<template>
  <div class="wide-responsive relative flex h-full flex-col flex-nowrap! overflow-hidden">
    <div class="relative flex flex-col flex-nowrap! gap-4 border-b p-6 pt-8">
      <PageDecorationImage />

      <h1 class="heading-md text-heading!">
        {{ $t('navigation_item_feedback') }}
      </h1>
    </div>

    <div class="p-6">
      <FeedbackForm />
    </div>
  </div>
</template>
